<template>
	<section class="box">
	<HeaderBar :is-prev="true"></HeaderBar>
	  <div class="main"></div>
 	</section>

</template>

<script>
import HeaderBar from './base/header'
export default {
	components: {
    HeaderBar
   

  },
  name: 'rgfw',
  

}
</script>


<style scoped>
.box{height: 100%;width: 100%;background:#e6e6e6;}
.main{width: 5.25rem;height: 6.8rem;background:url(../assets/go-wx.png) no-repeat;background-size: cover;margin-left: 1.18rem;margin-top: 1.29rem;}

</style>



// WEBPACK FOOTER //
// src/components/rgfw.vue